export const GUEST_UPDATE_BOOKING_FORM = 'GUEST_UPDATE_BOOKING_FORM';
